/*
 * Blind hero — desktop gallery sticky offset.
 *
 * Keep the left gallery and breadcrumbs clear of the sticky header while the longer
 * product info column scrolls.
 */
(function () {
  'use strict';
  var page = document.querySelector('.bps1-page');
  if (!page) return;

  var desktopQuery = window.matchMedia('(min-width: 1068px)');
  var gallery = page.querySelector('.product-gallery-sticky');
  var heroGrid = page.querySelector('.product-grid-container');
  var breadcrumbsSection = document.querySelector('.breadcrumbs-section');
  var breadcrumbsRow = breadcrumbsSection && breadcrumbsSection.querySelector('.breadcrumbs-row');
  var stickyTop = null;
  var breadcrumbsTop = null;
  var resizeTimer = 0;

  if (!gallery) return;

  function getHeaderHeight() {
    var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    if (headerHeight > 0) return headerHeight;

    var header = document.querySelector('.header-section, .tp-header--sticky');
    return header ? header.offsetHeight : 0;
  }

  function clearBreadcrumbsSticky() {
    if (!breadcrumbsRow || !breadcrumbsSection) return;

    breadcrumbsRow.classList.remove('bps1-breadcrumbs-row--fixed');
    breadcrumbsRow.style.removeProperty('--bps1-breadcrumbs-sticky-top');
    breadcrumbsSection.style.removeProperty('min-height');
  }

  function clearStickyTop() {
    stickyTop = null;
    breadcrumbsTop = null;
    page.style.removeProperty('--bps1-gallery-sticky-top');
    clearBreadcrumbsSticky();
  }

  function syncBreadcrumbsSticky() {
    if (!breadcrumbsRow || !breadcrumbsSection || !heroGrid || stickyTop === null || breadcrumbsTop === null) {
      clearBreadcrumbsSticky();
      return;
    }

    if (!desktopQuery.matches || window.scrollY <= 0) {
      clearBreadcrumbsSticky();
      return;
    }

    var heroBottom = window.scrollY + heroGrid.getBoundingClientRect().bottom;
    var galleryHeight = gallery.offsetHeight;
    var stickyStopScroll = heroBottom - (stickyTop + galleryHeight);

    if (window.scrollY > stickyStopScroll) {
      clearBreadcrumbsSticky();
      return;
    }

    breadcrumbsSection.style.minHeight = breadcrumbsRow.offsetHeight + 'px';
    breadcrumbsRow.style.setProperty('--bps1-breadcrumbs-sticky-top', breadcrumbsTop + 'px');
    breadcrumbsRow.classList.add('bps1-breadcrumbs-row--fixed');
  }

  function measureStickyTop() {
    if (!desktopQuery.matches) {
      clearStickyTop();
      return;
    }

    if (window.scrollY > 0 && stickyTop !== null) {
      page.style.setProperty('--bps1-gallery-sticky-top', stickyTop + 'px');
      syncBreadcrumbsSticky();
      return;
    }

    requestAnimationFrame(function () {
      var headerHeight = getHeaderHeight();
      var stickyGap = 12;

      breadcrumbsTop = Math.ceil(headerHeight + stickyGap);
      stickyTop = breadcrumbsRow
        ? Math.ceil(breadcrumbsTop + breadcrumbsRow.offsetHeight + stickyGap)
        : Math.ceil(headerHeight + 20);

      page.style.setProperty('--bps1-gallery-sticky-top', stickyTop + 'px');

      syncBreadcrumbsSticky();
    });
  }

  function scheduleMeasure() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(measureStickyTop, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureStickyTop);
  } else {
    measureStickyTop();
  }

  window.addEventListener('load', measureStickyTop);
  window.addEventListener('scroll', syncBreadcrumbsSticky, { passive: true });
  window.addEventListener('resize', scheduleMeasure);

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', measureStickyTop);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(measureStickyTop);
  }
})();

/*
 * BPS1 rating stars -> Loox reviews.
 *
 * The Loox app section is configured in product templates with section id
 * `1706330108a46cc747`; Shopify renders that id with a template prefix in the
 * DOM, while Loox may also inject its own `#looxReviews` anchor. Support both.
 */
(function () {
  'use strict';
  var page = document.querySelector('.bps1-page');
  if (!page) return;

  var LOOX_SECTION_ID = '1706330108a46cc747';

  function getHeaderOffset() {
    var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    if (headerHeight > 0) return headerHeight + 16;

    var header = document.querySelector('.header-section, .tp-header--sticky');
    return header ? header.offsetHeight + 16 : 16;
  }

  function findLooxTarget() {
    return document.getElementById('looxReviews') ||
      document.querySelector('[id*="__' + LOOX_SECTION_ID + '"]') ||
      document.querySelector('[id*="loox_reviews_loox_dynamic_section_3fGCLp"]');
  }

  function scrollToTarget(target) {
    var targetTop = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: 'smooth'
    });
  }

  page.addEventListener('click', function (event) {
    var trigger = event.target.closest('.bps1-stars');
    if (!trigger || !page.contains(trigger)) return;

    var target = findLooxTarget();
    if (!target) return;

    event.preventDefault();
    scrollToTarget(target);

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#looxReviews');
    }
  });
})();

/*
 * Blind hero JS — desktop gallery wheel/swipe + mobile sticky-bar scroll behaviour.
 *
 * SCOPE: runs on product.blind-pack-s1 AND product.blind-box-s1 (guarded by the `.bps1-page`
 * wrapper class, and only loaded for those templates from sections/main-product.liquid). It does NOT
 * touch the shared gallery code — it reuses the existing Flickity instance created by
 * <product-slider> (assets/product.js) via Flickity.data(), so dots / thumbnails / arrows
 * / variant image all stay in sync automatically.
 *
 * BEHAVIOUR: a clearly-horizontal wheel/trackpad gesture inside the main image area moves
 * the gallery (right → next, left → previous). Vertical scrolling is never intercepted, and
 * one gesture = one step (throttled), so normal mouse-wheel scrolling can't flip images.
 * Touch swipe and mouse drag already work natively (Flickity draggable).
 */
(function () {
  'use strict';
  if (!document.querySelector('.bps1-page')) return;

  function init() {
    var slider = document.querySelector('.thb-product-detail product-slider');
    if (!slider || !window.Flickity) return;

    var lockUntil = 0;
    var H_THRESHOLD = 8;   // ignore tiny horizontal jitter
    var COOLDOWN = 450;    // ms — one image change per gesture

    slider.addEventListener('wheel', function (e) {
      // Only act on horizontal-dominant gestures; let vertical page scroll pass through.
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      if (Math.abs(e.deltaX) < H_THRESHOLD) return;

      // We're handling a horizontal gesture → stop the browser's horizontal scroll / swipe-back.
      e.preventDefault();

      var now = Date.now();
      if (now < lockUntil) return;

      var flkty = window.Flickity.data(slider);
      if (!flkty || !flkty.cells || flkty.cells.length < 2) return;

      if (e.deltaX > 0) {
        flkty.next();      // scroll/swipe right → next image
      } else {
        flkty.previous();  // scroll/swipe left → previous image
      }
      lockUntil = now + COOLDOWN;
    }, { passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * Blind-Pack-S1 — mobile (≤550px) sticky Add-to-Cart reveal.
 *
 * The real buy buttons stay in Product Information. This controls the theme's sticky
 * clone and reveals it once the real Add to Cart button has been scrolled past,
 * then hides it again near the footer.
 */
(function () {
  'use strict';
  var page = document.querySelector('.bps1-page');
  if (!page) return;

  function initStickyBar() {
    var sticky = document.querySelector('.thb-product-detail .product-add-to-cart-sticky');
    var addToCartButton = document.querySelector('.thb-product-detail .add_to_cart_holder--multi #AddToCart');
    var footer = document.getElementById('footer') ||
                 document.querySelector('.tp-footer, footer, theme-footer, .footer');
    var mobileQuery = window.matchMedia('(max-width: 550px)');
    var footerInView = false;

    if (!sticky || !addToCartButton) return;

    function syncSticky() {
      if (!mobileQuery.matches) {
        page.classList.remove('bps1-sticky-atc-visible');
        return;
      }

      var buttonRect = addToCartButton.getBoundingClientRect();
      var hasPassedAddToCart = buttonRect.bottom <= 0;
      var shouldShowSticky = hasPassedAddToCart && !footerInView;

      page.classList.toggle('bps1-sticky-atc-visible', shouldShowSticky);
      sticky.classList.toggle('sticky--visible', shouldShowSticky);
    }

    if (footer && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          footerInView = entry.isIntersecting;
          syncSticky();
        });
      }, { root: null, rootMargin: '0px 0px 60px 0px', threshold: 0 });

      obs.observe(footer);
    }

    syncSticky();
    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncSticky);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(syncSticky);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
})();
